import styles from "./IconStyles.module.css";

/**
 * Icon for undo action used in the editor toolbar.
 *
 * @param props - Destructured parameter object
 * @param props.onClick - Click handler invoked when the undo icon is activated.
 * @param props.fill - Colour theme for the icon; accepts `"gray"` or `"black"`.
 */
export const UndoBtn = ({ onClick, fill }: { onClick: () => void; fill: "gray" | "black" }) => (
  <svg
    fill={fill}
    onClick={() => onClick()}
    xmlns="http://www.w3.org/2000/svg"
    height="16"
    viewBox="0 0 24 24"
    width="16"
    className={styles.undoBtn}
    aria-label="Undo"
  >
    <path
      d="M0 0h24v24H0z"
      fill="none"
    />
    <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
  </svg>
);

UndoBtn.displayName = "UndoBtn";
